import { connect } from 'react-redux'
import { IStoreState } from 'src/types/index'
import { getManyFeedbacks, actionCreators, updateFeedbackStatus } from 'src/state/actions/trips/index'
import { ITripFilters } from 'src/types'
import RiderFeedback from 'src/components/riders/riderdetails/RiderFeedback'
const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const organizations = state.organizations.currentOrgId
    ? state.organizations.items[state.organizations.currentOrgId]
    : null
  return {
    routeProps: ownProps,
    orgId: state.organizations.currentOrgId,
    riderId: ownProps.riderId,
    filters: state.trips.filters,
    services: Object.values(state.service.items),
    organizations
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchFeedbacks: (params: ITripFilters) => dispatch(getManyFeedbacks(params)),
    updateTripFilters: (params: ITripFilters) => dispatch(actionCreators.updateTripFilters(params)),
    updateFeedbackStatus: (tripId: string, feedbackStatus: string, prevFeedbackStatus: string) =>
      dispatch(updateFeedbackStatus(tripId, feedbackStatus, prevFeedbackStatus))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderFeedback)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/RiderFeedback.ts